import { useEffect, useRef } from "react";
import useForceUpdate from "../../../@hooks/useForceUpdate";
import service from "../../../@services";
import Events from "../../../@utils/events";
import Supplier from "./supplier";

class SupplierList extends Events {
  #listLoading = false
  get listLoading(){
    return this.#listLoading
  }
  #list = [];
  get list() {
    return this.#list;
  }
  #pager = {
    onChange:(pageIndex)=>{
      console.log(pageIndex)
      
      this.getList({ ...this.#filters,pageIndex})
    }
  };
  get pager() {
    return this.#pager;
  }
  #filters = {};
  constructor(filters) {
    super();
    this.#filters = filters;
    this.on('onSupplierAdded',()=>{ 
      this.getList(this.#filters)
    })
    this.on('onSupplierModified',()=>{ 
      this.getList(this.#filters)
    })
  }
  nextPage() {
    let { pageSize = 10, pageIndex = 0 } = this.#pager;
    return this.getList({
      ...(this.#filters || {}),
      pageSize,
      pageIndex: pageIndex + 1,
    });
  }
  getList(filters = {}) {
    this.#filters = filters;
    this.#listLoading = true;
    this.emit("updated");
    return service.supplier.page(this.#filters).then((res) => {
      let { result, pageCount, pageIndex, pageSize, recordCount } = res;
      this.#list = result || [].map((supplier) => new Supplier(supplier));
      this.#pager = {
        ...this.#pager,
        pageCount,
        current:pageIndex,
        pageSize,
        total:recordCount,
      };
      this.#listLoading = false;
      this.emit("updated");
    }).catch(e=>{
      this.#listLoading = false;
    });
  }
}

export default function useSupplierList() {
  const forceUpdate = useForceUpdate();
  const ref$supplierList = useRef(new SupplierList());
  useEffect(() => {
    const offUpdate = ref$supplierList.current.on("updated", forceUpdate);
    return () => {
      offUpdate();
    };
  }, [forceUpdate]);
  return [ref$supplierList.current];
}
